import React, { useEffect, useState } from "react";
import TableModalHeader from "../../UtilitiesComponent/TableModalHeader";
import {
  setPage,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setMonth,
  setYear,
  setSubmitPlace,
  setUserId,
  setManagerId,
  setQualityTeamId,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
} from "../../../redux-toolkit/slices/dashboard.website.approved.slice";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { FetchSubmitedVideos } from "../../../api/functions/submited.videos.api";
import { useQuery } from "react-query";
import ApiLoader from "../../Loaders/ApiLoader";
import EmptyTable from "../../EmptyTable/EmptyTable";
import NoResultTwo from "../../NoResult/NoResultTwo";
import DashboardModalFilterWrapper from "../../UtilitiesComponent/DashboardModalFilterWrapper";
import Filter from "../../Filter/Filter";
import DashboardVideosFilterModal from "../../FilterModal/DashboardVideosFilterModal ";
import DashboardModalVideosTable from "./Fragments/DashboardModalVideosTable";
import DashboardModalWrapper from "../ModalTableWrappers/DashboardModalWrapper";
import { getStartEndDateTwo } from "../../../lib/functions/utils.lib";

const DashboardWebsiteApprovedModal = (props) => {
  const { filterRowProps, modalHeaderProps, enable, tableDataProps, ...rest } =
    props;
  // const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const dispatch = useAppDispatch();

  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const {
    page,
    has_note,
    unreachable_submitter,
    hasMessage,
    month,
    year,
    submit_place,
    user_id,
    manager_id,
    quality_team_id,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
  } = useAppSelector((s) => s.dashboardWebsiteApprovedSlice);

  const filtersReset = () => {
    dispatch(setPage(1));
    dispatch(setHasNote(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setHasMessage(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setManagerId(null));
    dispatch(setQualityTeamId(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    dispatch(setFrom(null));
    dispatch(setTo(null));
    setSearch("");
    handleTriggreFetch();
  };

  const handleClearFilterModal = () => {
    dispatch(setHasNote(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setHasMessage(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setManagerId(null));
    dispatch(setQualityTeamId(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };

  //   console.warn("enable", enable);

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(
    ["website_approved"],
    async () =>
      FetchSubmitedVideos({
        page: search ? null : page,
        search,
        manager_decision: 5,
        quality_team_decision: 1,
        has_note,
        unreachable_submitter,
        hasMessage,
        month,
        year,
        user_id,
        manager_id,
        quality_team_id,
        people_appearing,
        person_who_filmed,
        aggrement_with_another_company,
        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
        submit_place: submit_other_website,
        country: submit_place,
      }),
    {
      enabled: enable,
    }
  );
  //   console.warn("data", data);

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };
  const filterRefetch = () => {
    refetchAgain();
    setOpenFilterModal(false);
  };
  const handlePageChange = (p) => {
    dispatch(setPage(p));
    handleTriggreFetch();
  };
  useEffect(() => {
    if (!enable || !search) return;
    // console.warn("debounce call--------------");

    const debounceTimeout = setTimeout(() => {
      refetchAgain();
    }, 1000);

    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [search]);

  const handleInputChange = (event) => {
    let inputValue = event.target.value;
    setSearch(inputValue);
    if (!inputValue) {
      filtersReset();
    }
  };

  useEffect(() => {
    if (enable) {
      refetchAgain();
    }
  }, [fetchTrigger]);

  const [filterActive, setFilterActive] = useState(false);

  useEffect(() => {
    if (
      search ||
      has_note ||
      unreachable_submitter ||
      hasMessage ||
      month ||
      year ||
      submit_place ||
      user_id ||
      manager_id ||
      quality_team_id ||
      people_appearing ||
      person_who_filmed ||
      submit_other_website ||
      aggrement_with_another_company
    ) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [
    search,
    has_note,
    unreachable_submitter,
    hasMessage,
    month,
    year,
    submit_place,
    user_id,
    manager_id,
    quality_team_id,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
  ]);

  return (
    <>
      <DashboardModalWrapper
        {...rest}
        modalHeader={<TableModalHeader {...modalHeaderProps} />}
        filterRow={
          <DashboardModalFilterWrapper
            filterModalProps={{
              ...tableDataProps,
              openFilterModal,
              setOpenFilterModal,
              handleTriggreFetch,
              data: data?.data,
              handleClearFilterModal,
              filtersReset,
              filterRefetch,
              handleInputChange,

              states: {
                search,
                has_note,
                unreachable_submitter,
                hasMessage,
                month,
                year,
                submit_place,
                user_id,
                manager_id,
                quality_team_id,
                people_appearing,
                person_who_filmed,
                submit_other_website,
                aggrement_with_another_company,
                from,
                to,
              },
              setStates: {
                setHasNote,
                setUnreachableSubmitter,
                setHasMessage,
                setMonth,
                setYear,
                setSubmitPlace,
                setUserId,
                setManagerId,
                setQualityTeamId,
                setPeopleAppearing,
                setPersonWhoFilmed,
                setSubmitOtherWebsite,
                setAgreementWithAnotherCompany,
                setFrom,
                setTo,
              },
            }}
            FilterModalComponent={DashboardVideosFilterModal}
            filterActive={filterActive}
          />
        }
      >
        <ApiLoader loading={isLoading} />
        <DashboardModalVideosTable
          datas={data?.data}
          page={page}
          handlePageChange={handlePageChange}
          {...tableDataProps}
          filtersReset={filtersReset}
          filterActive={filterActive}
          handleTriggreFetch={handleTriggreFetch}
          loading={isLoading}
        />
      </DashboardModalWrapper>
    </>
  );
};

export default DashboardWebsiteApprovedModal;
